var _a
import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import AddCircleOutlinedIcon from '@material-ui/icons/AddCircleOutlined'
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'
import ArrowRightIcon from '@material-ui/icons/ArrowRight'
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward'
import CallEndIcon from '@material-ui/icons/CallEnd'
import ChevronRight from '@material-ui/icons/ChevronRight'
import CloseIcon from '@material-ui/icons/Close'
import CreateNewFolderIcon from '@material-ui/icons/CreateNewFolder'
import DesktopWindowsIcon from '@material-ui/icons/DesktopWindows'
import DoneIcon from '@material-ui/icons/Done'
import ErrorIcon from '@material-ui/icons/Error'
import FilterIcon from '@material-ui/icons/Filter'
import FullScreenIcon from '@material-ui/icons/Fullscreen'
import FullScreenExitIcon from '@material-ui/icons/FullscreenExit'
import GetAppIcon from '@material-ui/icons/GetApp'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'
import InfoIcon from '@material-ui/icons/Info'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft'
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight'
import MicIcon from '@material-ui/icons/Mic'
import MicOffIcon from '@material-ui/icons/MicOff'
import NotificationsActive from '@material-ui/icons/NotificationsActive'
import PauseIcon from '@material-ui/icons/Pause'
import PermMediaIcon from '@material-ui/icons/PermMedia'
import PlayArrowIcon from '@material-ui/icons/PlayArrow'
import PlayCircleOutline from '@material-ui/icons/PlayCircleOutline'
import PublishIcon from '@material-ui/icons/Publish'
import RefreshIcon from '@material-ui/icons/Refresh'
import ReportIcon from '@material-ui/icons/Report'
import ScreenShareIcon from '@material-ui/icons/ScreenShare'
import SettingsIcon from '@material-ui/icons/Settings'
import StarIcon from '@material-ui/icons/Star'
import StarBorderIcon from '@material-ui/icons/StarBorder'
import StopScreenShareIcon from '@material-ui/icons/StopScreenShare'
import VideoCamIcon from '@material-ui/icons/Videocam'
import VideoCamOffIcon from '@material-ui/icons/VideocamOff'
import ViewListIcon from '@material-ui/icons/ViewList'
import WarningIcon from '@material-ui/icons/Warning'
import classNames from 'classnames'
import React from 'react'
import { ODSVGCloseX } from './svg/ODSVGCloseX'
import { ODSVGHamburgMenu } from './svg/ODSVGHamburgMenu'
import { ODSVGTwitter } from './svg/ODSVGTwitter'
export var ODIcons
;(function (ODIcons) {
  ODIcons[(ODIcons['Researcher'] = 0)] = 'Researcher'
  ODIcons[(ODIcons['Organization'] = 1)] = 'Organization'
  ODIcons[(ODIcons['TCFFile'] = 2)] = 'TCFFile'
  ODIcons[(ODIcons['Patient'] = 3)] = 'Patient'
  ODIcons[(ODIcons['Dashboard'] = 4)] = 'Dashboard'
  ODIcons[(ODIcons['Doctor'] = 5)] = 'Doctor'
  ODIcons[(ODIcons['Inquiry'] = 6)] = 'Inquiry'
  ODIcons[(ODIcons['CorePeople'] = 30000)] = 'CorePeople'
  ODIcons[(ODIcons['CoreSiteMap'] = 30001)] = 'CoreSiteMap'
  ODIcons[(ODIcons['CoreHttps'] = 30002)] = 'CoreHttps'
  ODIcons[(ODIcons['CoreSearch'] = 30003)] = 'CoreSearch'
  ODIcons[(ODIcons['CoreViewModule'] = 30004)] = 'CoreViewModule'
  ODIcons[(ODIcons['CoreSync'] = 30005)] = 'CoreSync'
  ODIcons[(ODIcons['CoreStar'] = 30006)] = 'CoreStar'
  ODIcons[(ODIcons['CoreList'] = 30007)] = 'CoreList'
  ODIcons[(ODIcons['CoreTag'] = 30008)] = 'CoreTag'
  ODIcons[(ODIcons['CoreTags'] = 30009)] = 'CoreTags'
  ODIcons[(ODIcons['CoreSettings'] = 30010)] = 'CoreSettings'
  ODIcons[(ODIcons['CoreLibrary'] = 30011)] = 'CoreLibrary'
  ODIcons[(ODIcons['CoreAccountLogout'] = 30012)] = 'CoreAccountLogout'
  ODIcons[(ODIcons['CoreCheckAlt'] = 30013)] = 'CoreCheckAlt'
  ODIcons[(ODIcons['CoreStorage'] = 30014)] = 'CoreStorage'
  ODIcons[(ODIcons['CoreX'] = 30015)] = 'CoreX'
  ODIcons[(ODIcons['CoreEnvelopeClosed'] = 30016)] = 'CoreEnvelopeClosed'
  ODIcons[(ODIcons['CoreArrowCircleLeft'] = 30017)] = 'CoreArrowCircleLeft'
  ODIcons[(ODIcons['CoreFrown'] = 30018)] = 'CoreFrown'
  ODIcons[(ODIcons['CoreLibraryAdd'] = 30019)] = 'CoreLibraryAdd'
  ODIcons[(ODIcons['CoreDataTransferDown'] = 30020)] = 'CoreDataTransferDown'
  ODIcons[(ODIcons['CorePencil'] = 30021)] = 'CorePencil'
  ODIcons[(ODIcons['CoreSave'] = 30022)] = 'CoreSave'
  ODIcons[(ODIcons['CoreTrash'] = 30023)] = 'CoreTrash'
  ODIcons[(ODIcons['CoreXCircle'] = 30024)] = 'CoreXCircle'
  ODIcons[(ODIcons['CoreImagePlus'] = 30025)] = 'CoreImagePlus'
  ODIcons[(ODIcons['CorePlus'] = 30026)] = 'CorePlus'
  ODIcons[(ODIcons['CoreArrowCircleBottom'] = 30027)] = 'CoreArrowCircleBottom'
  ODIcons[(ODIcons['CoreArrowCircleTop'] = 30028)] = 'CoreArrowCircleTop'
  ODIcons[(ODIcons['CoreMediaPause'] = 30029)] = 'CoreMediaPause'
  ODIcons[(ODIcons['CoreMediaPlay'] = 30030)] = 'CoreMediaPlay'
  ODIcons[(ODIcons['CoreReload'] = 30031)] = 'CoreReload'
  ODIcons[(ODIcons['CoreLink'] = 30032)] = 'CoreLink'
  ODIcons[(ODIcons['CoreFolder'] = 30033)] = 'CoreFolder'
  ODIcons[(ODIcons['CoreAvTimer'] = 30034)] = 'CoreAvTimer'
  ODIcons[(ODIcons['CoreShare'] = 30035)] = 'CoreShare'
  ODIcons[(ODIcons['CoreFolderOpen'] = 30036)] = 'CoreFolderOpen'
  ODIcons[(ODIcons['CoreBuilding'] = 30037)] = 'CoreBuilding'
  ODIcons[(ODIcons['CoreGrid'] = 30038)] = 'CoreGrid'
  ODIcons[(ODIcons['CoreGridSlash'] = 30039)] = 'CoreGridSlash'
  ODIcons[(ODIcons['CoreHospital'] = 30040)] = 'CoreHospital'
  ODIcons[(ODIcons['CoreEnvelopeLetter'] = 30041)] = 'CoreEnvelopeLetter'
  ODIcons[(ODIcons['CoreCalendar'] = 30042)] = 'CoreCalendar'
  ODIcons[(ODIcons['CoreCheckCircle'] = 30043)] = 'CoreCheckCircle'
  ODIcons[(ODIcons['CoreContact'] = 30044)] = 'CoreContact'
  ODIcons[(ODIcons['CoreClipboard'] = 30045)] = 'CoreClipboard'
  ODIcons[(ODIcons['CoreUserUnfollow'] = 30046)] = 'CoreUserUnfollow'
  ODIcons[(ODIcons['CoreCalendarCheck'] = 30047)] = 'CoreCalendarCheck'
  ODIcons[(ODIcons['CoreHistory'] = 30048)] = 'CoreHistory'
  ODIcons[(ODIcons['CoreFile'] = 30049)] = 'CoreFile'
  ODIcons[(ODIcons['CoreUser'] = 30050)] = 'CoreUser'
  ODIcons[(ODIcons['CoreBed'] = 30051)] = 'CoreBed'
  ODIcons[(ODIcons['CoreSmoke'] = 30052)] = 'CoreSmoke'
  ODIcons[(ODIcons['CoreBookmark'] = 30053)] = 'CoreBookmark'
  ODIcons[(ODIcons['CoreCreditCard'] = 30054)] = 'CoreCreditCard'
  ODIcons[(ODIcons['CorePaperPlaneSend'] = 30055)] = 'CorePaperPlaneSend'
  ODIcons[(ODIcons['CoreHighlighter'] = 30056)] = 'CoreHighlighter'
  ODIcons[(ODIcons['CoreTerminal'] = 30057)] = 'CoreTerminal'
  ODIcons[(ODIcons['CoreSpeech'] = 30058)] = 'CoreSpeech'
  ODIcons[(ODIcons['CoreFilterPhoto'] = 30059)] = 'CoreFilterPhoto'
  ODIcons[(ODIcons['CoreNewspaper'] = 30060)] = 'CoreNewspaper'
  ODIcons[(ODIcons['CoreSettingCog'] = 30061)] = 'CoreSettingCog'
  ODIcons[(ODIcons['CoreMobile'] = 30062)] = 'CoreMobile'
  ODIcons[(ODIcons['CoreFullscreenExit'] = 30063)] = 'CoreFullscreenExit'
  ODIcons[(ODIcons['CoreChatBubble'] = 30064)] = 'CoreChatBubble'
  ODIcons[(ODIcons['CoreFullscreen'] = 30065)] = 'CoreFullscreen'
  ODIcons[(ODIcons['CoreMagnifyingGlass'] = 30066)] = 'CoreMagnifyingGlass'
  ODIcons[(ODIcons['CoreSatelite'] = 30067)] = 'CoreSatelite'
  ODIcons[(ODIcons['CoreShareAlt'] = 30068)] = 'CoreShareAlt'
  ODIcons[(ODIcons['MaterialClose'] = 60000)] = 'MaterialClose'
  ODIcons[(ODIcons['MaterialSettings'] = 60001)] = 'MaterialSettings'
  ODIcons[(ODIcons['MaterialArrowLeft'] = 60002)] = 'MaterialArrowLeft'
  ODIcons[(ODIcons['MaterialArrowRight'] = 60003)] = 'MaterialArrowRight'
  ODIcons[(ODIcons['MaterialError'] = 60004)] = 'MaterialError'
  ODIcons[(ODIcons['MaterialFilter'] = 60005)] = 'MaterialFilter'
  ODIcons[(ODIcons['MaterialStar'] = 60006)] = 'MaterialStar'
  ODIcons[(ODIcons['MaterialStarBorder'] = 60007)] = 'MaterialStarBorder'
  ODIcons[(ODIcons['MaterialArrowDropDownIcon'] = 60008)] = 'MaterialArrowDropDownIcon'
  ODIcons[(ODIcons['MaterialArrowUpwardIcon'] = 60009)] = 'MaterialArrowUpwardIcon'
  ODIcons[(ODIcons['MaterialArrowDownwardIcon'] = 60010)] = 'MaterialArrowDownwardIcon'
  ODIcons[(ODIcons['MaterialArrowForwardIcon'] = 60011)] = 'MaterialArrowForwardIcon'
  ODIcons[(ODIcons['MaterialArrowRightIcon'] = 60012)] = 'MaterialArrowRightIcon'
  ODIcons[(ODIcons['MaterialFileDownload'] = 60013)] = 'MaterialFileDownload'
  ODIcons[(ODIcons['MaterialFileUpload'] = 60014)] = 'MaterialFileUpload'
  ODIcons[(ODIcons['MaterialAddCircleOutlined'] = 60015)] = 'MaterialAddCircleOutlined'
  ODIcons[(ODIcons['MaterialReport'] = 60016)] = 'MaterialReport'
  ODIcons[(ODIcons['MaterialRefresh'] = 60017)] = 'MaterialRefresh'
  ODIcons[(ODIcons['MaterialPermMedia'] = 60018)] = 'MaterialPermMedia'
  ODIcons[(ODIcons['MaterialPlayArrow'] = 60019)] = 'MaterialPlayArrow'
  ODIcons[(ODIcons['MaterialPause'] = 60020)] = 'MaterialPause'
  ODIcons[(ODIcons['MaterialCreateNewFolder'] = 60021)] = 'MaterialCreateNewFolder'
  ODIcons[(ODIcons['MaterialViewList'] = 60022)] = 'MaterialViewList'
  ODIcons[(ODIcons['MaterialMic'] = 60023)] = 'MaterialMic'
  ODIcons[(ODIcons['MaterialMicOff'] = 60024)] = 'MaterialMicOff'
  ODIcons[(ODIcons['MaterialVideoCam'] = 60025)] = 'MaterialVideoCam'
  ODIcons[(ODIcons['MaterialVideoCamOff'] = 60026)] = 'MaterialVideoCamOff'
  ODIcons[(ODIcons['MaterialShareScreen'] = 60027)] = 'MaterialShareScreen'
  ODIcons[(ODIcons['MaterialFullscreen'] = 60028)] = 'MaterialFullscreen'
  ODIcons[(ODIcons['MaterialFullscreenExit'] = 60029)] = 'MaterialFullscreenExit'
  ODIcons[(ODIcons['MaterialCallEnd'] = 60030)] = 'MaterialCallEnd'
  ODIcons[(ODIcons['MaterialDesktopWindows'] = 60031)] = 'MaterialDesktopWindows'
  ODIcons[(ODIcons['MaterialStopScreenShare'] = 60032)] = 'MaterialStopScreenShare'
  ODIcons[(ODIcons['MaterialInfoOutline'] = 60033)] = 'MaterialInfoOutline'
  ODIcons[(ODIcons['MaterialChevronRight'] = 60034)] = 'MaterialChevronRight'
  ODIcons[(ODIcons['MaterialNotificationsActive'] = 60035)] = 'MaterialNotificationsActive'
  ODIcons[(ODIcons['MaterialAccountCircle'] = 60036)] = 'MaterialAccountCircle'
  ODIcons[(ODIcons['MaterialPlayCircleOutline'] = 60037)] = 'MaterialPlayCircleOutline'
  ODIcons[(ODIcons['MaterialDone'] = 60038)] = 'MaterialDone'
  ODIcons[(ODIcons['MaterialWarning'] = 60039)] = 'MaterialWarning'
  ODIcons[(ODIcons['MaterialInfo'] = 60040)] = 'MaterialInfo'
  ODIcons[(ODIcons['MaterialHelpOutline'] = 60041)] = 'MaterialHelpOutline'
  ODIcons[(ODIcons['SimpleLineIconsShareAlt'] = 70000)] = 'SimpleLineIconsShareAlt'
  ODIcons[(ODIcons['SimpleLineIconsFolder'] = 70001)] = 'SimpleLineIconsFolder'
  ODIcons[(ODIcons['FontAwesomeArrowCircleRight'] = 90000)] = 'FontAwesomeArrowCircleRight'
  ODIcons[(ODIcons['FontAwesomeStarOutlined'] = 90001)] = 'FontAwesomeStarOutlined'
  ODIcons[(ODIcons['FontAwesomeStar'] = 90002)] = 'FontAwesomeStar'
  ODIcons[(ODIcons['SVGIconHamburg'] = 110000)] = 'SVGIconHamburg'
  ODIcons[(ODIcons['SVGIconCloseX'] = 110001)] = 'SVGIconCloseX'
  ODIcons[(ODIcons['SVGIconTwitter'] = 110002)] = 'SVGIconTwitter'
})(ODIcons || (ODIcons = {}))
export var IconSet
;(function (IconSet) {
  IconSet['ODCode'] = 'ico-odcode'
  IconSet['CoreUI'] = 'ico-cui'
  IconSet['Material'] = 'ico-material'
  IconSet['FontAwesome'] = 'ico-fa'
  IconSet['SimpleLineIcons'] = 'ico-sli'
  IconSet['SVGIcon'] = 'ico-svg'
})(IconSet || (IconSet = {}))
var createIcon = function (iconSet, name, code, node) {
  return {
    iconSet: iconSet,
    name: name,
    code: code,
    node: node,
  }
}
export var IconsDefinition =
  ((_a = {}),
  (_a[ODIcons.Researcher] = createIcon(IconSet.ODCode, 'researcher', 'e900')),
  (_a[ODIcons.Organization] = createIcon(IconSet.ODCode, 'organization', 'e901')),
  (_a[ODIcons.TCFFile] = createIcon(IconSet.ODCode, 'tcffile', 'e902')),
  (_a[ODIcons.Dashboard] = createIcon(IconSet.ODCode, 'dashboard', 'e903')),
  (_a[ODIcons.Doctor] = createIcon(IconSet.ODCode, 'doctor', 'e904')),
  (_a[ODIcons.Inquiry] = createIcon(IconSet.ODCode, 'inquiry', 'e905')),
  (_a[ODIcons.Patient] = createIcon(IconSet.ODCode, 'patient', 'e906')),
  (_a[ODIcons.CorePeople] = createIcon(IconSet.CoreUI, 'cil-people')),
  (_a[ODIcons.CoreSiteMap] = createIcon(IconSet.CoreUI, 'cil-sitemap')),
  (_a[ODIcons.CoreHttps] = createIcon(IconSet.CoreUI, 'cil-https')),
  (_a[ODIcons.CoreSearch] = createIcon(IconSet.CoreUI, 'cil-magnifying-glass', '')),
  (_a[ODIcons.CoreViewModule] = createIcon(IconSet.CoreUI, 'cil-view-module', '')),
  (_a[ODIcons.CoreSync] = createIcon(IconSet.CoreUI, 'cil-sync', '')),
  (_a[ODIcons.CoreStar] = createIcon(IconSet.CoreUI, 'cil-star', '')),
  (_a[ODIcons.CoreList] = createIcon(IconSet.CoreUI, 'cil-list', '')),
  (_a[ODIcons.CoreTag] = createIcon(IconSet.CoreUI, 'cil-tag', '')),
  (_a[ODIcons.CoreTags] = createIcon(IconSet.CoreUI, 'cil-tags', '')),
  (_a[ODIcons.CoreSettings] = createIcon(IconSet.CoreUI, 'cil-settings', '')),
  (_a[ODIcons.CoreLibrary] = createIcon(IconSet.CoreUI, 'cil-library', '')),
  (_a[ODIcons.CoreAccountLogout] = createIcon(IconSet.CoreUI, 'cil-account-logout', '')),
  (_a[ODIcons.CoreCheckAlt] = createIcon(IconSet.CoreUI, 'cil-check-alt', '')),
  (_a[ODIcons.CoreStorage] = createIcon(IconSet.CoreUI, 'cil-storage', '')),
  (_a[ODIcons.CoreX] = createIcon(IconSet.CoreUI, 'cil-x', '')),
  (_a[ODIcons.CoreXCircle] = createIcon(IconSet.CoreUI, 'cil-x-circle', '')),
  (_a[ODIcons.CoreEnvelopeClosed] = createIcon(IconSet.CoreUI, 'cil-envelope-closed', '')),
  (_a[ODIcons.CoreArrowCircleLeft] = createIcon(IconSet.CoreUI, 'cil-arrow-circle-left', '')),
  (_a[ODIcons.CoreFrown] = createIcon(IconSet.CoreUI, 'cil-frown', '')),
  (_a[ODIcons.CoreLibraryAdd] = createIcon(IconSet.CoreUI, 'cil-library-add', '')),
  (_a[ODIcons.CoreDataTransferDown] = createIcon(IconSet.CoreUI, 'cil-data-transfer-down', '')),
  (_a[ODIcons.CorePencil] = createIcon(IconSet.CoreUI, 'cil-pencil', '')),
  (_a[ODIcons.CoreSave] = createIcon(IconSet.CoreUI, 'cil-save', '')),
  (_a[ODIcons.CoreTrash] = createIcon(IconSet.CoreUI, 'cil-trash', '')),
  (_a[ODIcons.CoreImagePlus] = createIcon(IconSet.CoreUI, 'cil-image-plus', '')),
  (_a[ODIcons.CorePlus] = createIcon(IconSet.CoreUI, 'cil-plus', '')),
  (_a[ODIcons.CoreArrowCircleBottom] = createIcon(IconSet.CoreUI, 'cil-arrow-circle-bottom', '')),
  (_a[ODIcons.CoreArrowCircleTop] = createIcon(IconSet.CoreUI, 'cil-arrow-circle-top', '')),
  (_a[ODIcons.CoreMediaPause] = createIcon(IconSet.CoreUI, 'cil-media-pause', '')),
  (_a[ODIcons.CoreMediaPlay] = createIcon(IconSet.CoreUI, 'cil-media-play', '')),
  (_a[ODIcons.CoreReload] = createIcon(IconSet.CoreUI, 'cil-reload', '')),
  (_a[ODIcons.CoreLink] = createIcon(IconSet.CoreUI, 'cil-link', '')),
  (_a[ODIcons.CoreFolder] = createIcon(IconSet.CoreUI, 'cil-folder', '')),
  (_a[ODIcons.CoreFolderOpen] = createIcon(IconSet.CoreUI, 'cil-folder-open', '')),
  (_a[ODIcons.CoreBuilding] = createIcon(IconSet.CoreUI, 'cil-building', '')),
  (_a[ODIcons.CoreAvTimer] = createIcon(IconSet.CoreUI, 'cil-av-timer', '')),
  (_a[ODIcons.CoreShare] = createIcon(IconSet.CoreUI, 'cil-share', '')),
  (_a[ODIcons.CoreGrid] = createIcon(IconSet.CoreUI, 'cil-grid', '')),
  (_a[ODIcons.CoreGridSlash] = createIcon(IconSet.CoreUI, 'cil-grid-slash', '')),
  (_a[ODIcons.CoreHospital] = createIcon(IconSet.CoreUI, 'cil-hospital', '')),
  (_a[ODIcons.CoreEnvelopeLetter] = createIcon(IconSet.CoreUI, 'cil-envelope-letter', '')),
  (_a[ODIcons.CoreCalendar] = createIcon(IconSet.CoreUI, 'cil-calendar', '')),
  (_a[ODIcons.CoreCheckCircle] = createIcon(IconSet.CoreUI, 'cil-check-circle', '')),
  (_a[ODIcons.CoreContact] = createIcon(IconSet.CoreUI, 'cil-contact', '')),
  (_a[ODIcons.CoreClipboard] = createIcon(IconSet.CoreUI, 'cil-clipboard', '')),
  (_a[ODIcons.CoreUserUnfollow] = createIcon(IconSet.CoreUI, 'cil-user-unfollow', '')),
  (_a[ODIcons.CoreCalendarCheck] = createIcon(IconSet.CoreUI, 'cil-calendar-check', '')),
  (_a[ODIcons.CoreHistory] = createIcon(IconSet.CoreUI, 'cil-history', '')),
  (_a[ODIcons.CoreFile] = createIcon(IconSet.CoreUI, 'cil-file', '')),
  (_a[ODIcons.CoreUser] = createIcon(IconSet.CoreUI, 'cil-user', '')),
  (_a[ODIcons.CoreBed] = createIcon(IconSet.CoreUI, 'cil-bed', '')),
  (_a[ODIcons.CoreSmoke] = createIcon(IconSet.CoreUI, 'cil-smoke', '')),
  (_a[ODIcons.CoreBookmark] = createIcon(IconSet.CoreUI, 'cil-bookmark', '')),
  (_a[ODIcons.CoreCreditCard] = createIcon(IconSet.CoreUI, 'cil-credit-card', '')),
  (_a[ODIcons.CorePaperPlaneSend] = createIcon(IconSet.CoreUI, 'cil-paper-plane', '')),
  (_a[ODIcons.CoreHighlighter] = createIcon(IconSet.CoreUI, 'cil-highlighter', '')),
  (_a[ODIcons.CoreTerminal] = createIcon(IconSet.CoreUI, 'cil-terminal', '')),
  (_a[ODIcons.CoreSpeech] = createIcon(IconSet.CoreUI, 'cil-speech', '')),
  (_a[ODIcons.CoreFilterPhoto] = createIcon(IconSet.CoreUI, 'cil-filter-photo', '')),
  (_a[ODIcons.CoreNewspaper] = createIcon(IconSet.CoreUI, 'cil-newspaper', '')),
  (_a[ODIcons.CoreSettingCog] = createIcon(IconSet.CoreUI, 'cil-cog', '')),
  (_a[ODIcons.CoreMobile] = createIcon(IconSet.CoreUI, 'cil-mobile', '')),
  (_a[ODIcons.CoreFullscreenExit] = createIcon(IconSet.CoreUI, 'cil-fullscreen-exit', '')),
  (_a[ODIcons.CoreChatBubble] = createIcon(IconSet.CoreUI, 'cil-chat-bubble', '')),
  (_a[ODIcons.CoreFullscreen] = createIcon(IconSet.CoreUI, 'cil-fullscreen', '')),
  (_a[ODIcons.CoreMagnifyingGlass] = createIcon(IconSet.CoreUI, 'cil-magnifying-glass', '')),
  (_a[ODIcons.CoreShareAlt] = createIcon(IconSet.CoreUI, 'cil-share-alt', '')),
  (_a[ODIcons.CoreSatelite] = createIcon(IconSet.CoreUI, 'cil-satelite', '')),
  (_a[ODIcons.MaterialClose] = createIcon(IconSet.Material, 'close', '', CloseIcon)),
  (_a[ODIcons.MaterialSettings] = createIcon(IconSet.Material, 'settings', '', SettingsIcon)),
  (_a[ODIcons.MaterialArrowLeft] = createIcon(IconSet.Material, 'arrow-left', '', KeyboardArrowLeftIcon)),
  (_a[ODIcons.MaterialArrowRight] = createIcon(IconSet.Material, 'arrow-right', '', KeyboardArrowRightIcon)),
  (_a[ODIcons.MaterialError] = createIcon(IconSet.Material, 'error', '', ErrorIcon)),
  (_a[ODIcons.MaterialFilter] = createIcon(IconSet.Material, 'filter', '', FilterIcon)),
  (_a[ODIcons.MaterialStar] = createIcon(IconSet.Material, 'star', '', StarIcon)),
  (_a[ODIcons.MaterialStarBorder] = createIcon(IconSet.Material, 'star-border', '', StarBorderIcon)),
  (_a[ODIcons.MaterialFileDownload] = createIcon(IconSet.Material, 'file_download', '', GetAppIcon)),
  (_a[ODIcons.MaterialFileUpload] = createIcon(IconSet.Material, 'file_upload', '', PublishIcon)),
  (_a[ODIcons.MaterialAddCircleOutlined] = createIcon(
    IconSet.Material,
    'add_circle_outline',
    '',
    AddCircleOutlinedIcon
  )),
  (_a[ODIcons.MaterialArrowDropDownIcon] = createIcon(IconSet.Material, 'ArrowDropDown', '', ArrowDropDownIcon)),
  (_a[ODIcons.MaterialArrowUpwardIcon] = createIcon(IconSet.Material, 'ArrowUpward', '', ArrowUpwardIcon)),
  (_a[ODIcons.MaterialArrowDownwardIcon] = createIcon(IconSet.Material, 'ArrowDownward', '', ArrowDownwardIcon)),
  (_a[ODIcons.MaterialArrowForwardIcon] = createIcon(IconSet.Material, 'ArrowForward', '', ArrowForwardIcon)),
  (_a[ODIcons.MaterialArrowRightIcon] = createIcon(IconSet.Material, 'ArrowRight', '', ArrowRightIcon)),
  (_a[ODIcons.MaterialReport] = createIcon(IconSet.Material, 'Report', '', ReportIcon)),
  (_a[ODIcons.MaterialRefresh] = createIcon(IconSet.Material, 'Refresh', '', RefreshIcon)),
  (_a[ODIcons.MaterialPermMedia] = createIcon(IconSet.Material, 'perm_media', '', PermMediaIcon)),
  (_a[ODIcons.MaterialPlayArrow] = createIcon(IconSet.Material, 'play_arrow', '', PlayArrowIcon)),
  (_a[ODIcons.MaterialPause] = createIcon(IconSet.Material, 'pause', '', PauseIcon)),
  (_a[ODIcons.MaterialCreateNewFolder] = createIcon(IconSet.Material, 'create_new_folder', '', CreateNewFolderIcon)),
  (_a[ODIcons.MaterialViewList] = createIcon(IconSet.Material, 'view_list', '', ViewListIcon)),
  (_a[ODIcons.MaterialMic] = createIcon(IconSet.Material, 'mic', '', MicIcon)),
  (_a[ODIcons.MaterialMicOff] = createIcon(IconSet.Material, 'mic_off', '', MicOffIcon)),
  (_a[ODIcons.MaterialVideoCam] = createIcon(IconSet.Material, 'video_cam', '', VideoCamIcon)),
  (_a[ODIcons.MaterialVideoCamOff] = createIcon(IconSet.Material, 'video_cam_off', '', VideoCamOffIcon)),
  (_a[ODIcons.MaterialShareScreen] = createIcon(IconSet.Material, 'share_screen', '', ScreenShareIcon)),
  (_a[ODIcons.MaterialFullscreen] = createIcon(IconSet.Material, 'fullscreen', '', FullScreenIcon)),
  (_a[ODIcons.MaterialFullscreenExit] = createIcon(IconSet.Material, 'fullscreen_exit', '', FullScreenExitIcon)),
  (_a[ODIcons.MaterialCallEnd] = createIcon(IconSet.Material, 'call_end', '', CallEndIcon)),
  (_a[ODIcons.MaterialDesktopWindows] = createIcon(IconSet.Material, 'desktop_windows', '', DesktopWindowsIcon)),
  (_a[ODIcons.MaterialStopScreenShare] = createIcon(IconSet.Material, 'stop_screen_share', '', StopScreenShareIcon)),
  (_a[ODIcons.MaterialInfoOutline] = createIcon(IconSet.Material, 'info_outlined', '', InfoOutlinedIcon)),
  (_a[ODIcons.MaterialChevronRight] = createIcon(IconSet.Material, 'chevron_right', '', ChevronRight)),
  (_a[ODIcons.MaterialNotificationsActive] = createIcon(
    IconSet.Material,
    'notifications_active',
    '',
    NotificationsActive
  )),
  (_a[ODIcons.MaterialAccountCircle] = createIcon(IconSet.Material, 'account_circle', '', AccountCircleIcon)),
  (_a[ODIcons.MaterialPlayCircleOutline] = createIcon(IconSet.Material, 'play_circle_outline', '', PlayCircleOutline)),
  (_a[ODIcons.MaterialDone] = createIcon(IconSet.Material, 'done_material', '', DoneIcon)),
  (_a[ODIcons.MaterialWarning] = createIcon(IconSet.Material, 'warning_material', '', WarningIcon)),
  (_a[ODIcons.MaterialInfo] = createIcon(IconSet.Material, 'info_material', '', InfoIcon)),
  (_a[ODIcons.MaterialHelpOutline] = createIcon(IconSet.Material, 'help_outline', '', HelpOutlineIcon)),
  (_a[ODIcons.FontAwesomeStarOutlined] = createIcon(IconSet.FontAwesome, 'star-o', '')),
  (_a[ODIcons.FontAwesomeStar] = createIcon(IconSet.FontAwesome, 'star', '')),
  (_a[ODIcons.FontAwesomeArrowCircleRight] = createIcon(IconSet.FontAwesome, 'arrow-circle-right', '')),
  (_a[ODIcons.SimpleLineIconsShareAlt] = createIcon(IconSet.SimpleLineIcons, 'share-alt', '')),
  (_a[ODIcons.SimpleLineIconsFolder] = createIcon(IconSet.SimpleLineIcons, 'folder-alt', '')),
  (_a[ODIcons.SVGIconHamburg] = createIcon(IconSet.SVGIcon, '', '', ODSVGHamburgMenu)),
  (_a[ODIcons.SVGIconCloseX] = createIcon(IconSet.SVGIcon, '', '', ODSVGCloseX)),
  (_a[ODIcons.SVGIconTwitter] = createIcon(IconSet.SVGIcon, '', '', ODSVGTwitter)),
  _a)
export var getIconSetName = function (icon) {
  return IconsDefinition[icon].iconSet
}
export var ODIcon = function (_a) {
  var id = _a.id,
    icon = _a.icon,
    _b = _a.className,
    className = _b === void 0 ? '' : _b,
    _c = _a.style,
    style = _c === void 0 ? {} : _c,
    onClick = _a.onClick
  var _d = IconsDefinition[icon],
    iconSet = _d.iconSet,
    code = _d.code,
    name = _d.name,
    Node = _d.node
  switch (iconSet) {
    case IconSet.ODCode:
      return React.createElement('i', {
        id: id,
        'aria-hidden': 'true',
        'data-icon': '&#x' + code + ';',
        className: classNames(className, 'icon-od-menu-' + name),
        style: style,
        onClick: onClick,
      })
    case IconSet.CoreUI:
      var cls = classNames(name, 'icons')
      return React.createElement('i', { id: id, className: cls, style: style, onClick: onClick })
    case IconSet.FontAwesome:
      return React.createElement('i', {
        id: id,
        className: classNames('fa', 'fa-' + name),
        onClick: onClick,
        style: style,
      })
    case IconSet.Material:
      return React.createElement(Node, { id: id, style: style, onClick: onClick })
    case IconSet.SimpleLineIcons:
      return React.createElement('i', {
        id: id,
        className: classNames('icons', 'icon-' + name),
        onClick: onClick,
        style: style,
      })
    case IconSet.SVGIcon: {
      return React.createElement(Node, { id: id, onClick: onClick, className: className })
    }
  }
}
//# sourceMappingURL=ODIcon.js.map
